import { style } from '@vanilla-extract/css';

export const imageElement = style({
  position: 'relative',
  aspectRatio: 'var(--aspect-ratio)',
  borderRadius: 'var(--border-radius)',
  borderWidth: 'var(--border-width)',
  borderStyle: 'var(--border-style)',
  borderColor: 'var(--border-color)',
  overflow: 'hidden',
  boxShadow: 'var(--box-shadow)',
});

export const imgContainer = style({
  maxHeight: 'var(--max-height)',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  position: 'var(--position, relative)', // default to relative, just in case.
  top: 'var(--position-top)',
  right: 'var(--position-right)',
  bottom: 'var(--position-bottom)',
  transform: 'var(--position-transform)',
  left: 'var(--position-left)',
  zIndex: 'var(--z-index)',

  ':hover': {
    transform: 'var(--hover-container-transform)',
    opacity: 'var(--hover-container-opacity, inherit)',
    boxShadow: 'var(--hover-container-box-shadow)',
  },

  '@media': {
    'only screen and (--mobile)': {
      maxHeight: 'var(--mobile-max-height, var(--max-height))',
      width: 'var(--mobile-width, var(--width))',
      maxWidth: 'var(--mobile-max-width, var(--max-width))',
    },
  },
});

export const img = style({
  display: 'block',
  objectFit: 'var(--object-fit)',
  width: 'var(--width)',
  height: 'auto',
  '@media': {
    'only screen and (--mobile)': {
      width: 'var(--mobile-width)',
    },
  },
  ':hover': {
    transform: 'var(--hover-image-transform)',
  },
});

export const link = style({
  transition: 'all 0.3s',
  maxWidth: '100%',
  ':hover': {
    marginTop: '-10px',
    marginBottom: '10px',
  },
});
